import React from 'react'
import { Container, AnchorLinkToExamDetails, ContainerInformation } from './styles'
import { ModalHeader } from '../../ModalComponents/ModalHeader'
import { ReferringPhysicianDetails } from '../../ReferringPhysicianDetails'
import { IconComponent } from '~/assets/icons/component'
import { IEchocardiogramTest } from '~/interfaces'

interface EchocardiogramTestDetailsContentProps {
  echocardiogramTestDetails: IEchocardiogramTest
}

export const EchocardiogramTestDetailsContent = ({
  echocardiogramTestDetails
}: EchocardiogramTestDetailsContentProps): JSX.Element => {
  const { startDate, description, referringPhysician, reportLink } = echocardiogramTestDetails
  return (
    <Container>
      <ModalHeader title={description} datetime={startDate} />
      <ContainerInformation>
        <ReferringPhysicianDetails physician={referringPhysician} />

        <hr />

        <AnchorLinkToExamDetails href={reportLink} target="blank">
          <IconComponent name="arrowUpRightFromSquare" />
          <span>Visualizar Laudo e Imagem</span>
        </AnchorLinkToExamDetails>
      </ContainerInformation>
    </Container>
  )
}
